import axios from "./axios-auth";

const getInvoice = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/getinvoice",
      method: "POST",
      data: payload,
    })
      .then((resp) => {
        if (resp.status !== 200) {
          reject(resp.data);
        }
        resolve(resp.data);
      })
      .catch((err) => {
        console.log("getInvoice api err", err);
      });
  });

// const getInvoicePDF = (params) =>
//   new Promise((resolve, reject) => {
//     axios({
//       url: "/dv-adm/getinvoicepdf",
//       method: "GET",
//       params: params,
//       responseType: "blob",
//     })
//       .then((resp) => {
//         if (resp.status !== 200) {
//           reject(resp.data);
//         }
//         resolve(resp.data);
//       })
//       .catch((err) => {
//         console.log("getInvoicePDF api err", err);
//       });
//   });

const getClients = () =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/getclients",
      method: "GET",
    })
      .then((resp) => {
        if (resp.status !== 200) {
          reject(resp.data);
        }
        resolve(resp.data);
      })
      .catch((err) => {
        console.log("getClients api err", err);
      });
  });

const getClientById = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/getclientbyid",
      method: "GET",
      params: params,
    })
      .then((resp) => {
        if (resp.status !== 200) {
          reject(resp.data);
        }
        resolve(resp.data);
      })
      .catch((err) => {
        console.log("getClientById api err", err);
      });
  });

const getTransactionReport = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/gettransactionreport",
      method: "POST",
      params: payload.params,
      data: payload.data,
    })
      .then((resp) => {
        if (resp.status !== 200) {
          reject(resp.data);
        }
        resolve(resp.data);
      })
      .catch((err) => {
        console.log("getTransactionReport api err", err);
      });
  });

export {
  getInvoice,
  // getInvoicePDF,
  getClients,
  getClientById,
  getTransactionReport,
};
